import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "flowbite-react";

function CGroupBoxingQuantity({ orderid }) {
    const [completedQuantity, setCompletedQuantity] = useState([]);
    const [totalPieces, setTotalPieces] = useState(0);
    const url = localStorage.getItem("url");

    useEffect(() => {
        if (orderid) {
            fetchCompletedQuantity();
        }
    }, [orderid]);

    const fetchCompletedQuantity = async () => {
        try {
            const response = await axios.get(`/group_boxing/completed_group_boxing/${orderid}`);
            const result = response.data;

            if (Array.isArray(result) && result.length > 0) {
                const formatted = result[0].formatted_size_variant_quantity;

                if (Array.isArray(formatted) && formatted.length === 2) {
                    const [details, grandTotal] = formatted;

                    setCompletedQuantity(details);
                    setTotalPieces(grandTotal);
                }
            }
        } catch (error) {
            console.error("Error fetching completed quantity:", error);
        }
    };

    return (
        <div className="overflow-x-auto p-2">
            <Table hoverable>
                <Table.Head>
                    <Table.HeadCell>Color</Table.HeadCell>
                    <Table.HeadCell>Size Variant</Table.HeadCell>
                    <Table.HeadCell>Total</Table.HeadCell>
                </Table.Head>
                <Table.Body className="divide-y">
                    {completedQuantity.map((item, index) => (
                        <Table.Row key={index} className="bg-white">
                            <Table.Cell className="font-semibold">

                                <div className="flex items-center space-x-2">
                                    <div className="flex items-center justify-center">
                                        <img
                                            src={`${url}${item.colour_image}`}
                                            alt={item.color}
                                            className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md"
                                        />
                                    </div>
                                    <span>{item.color}</span>
                                </div>
                            </Table.Cell>
                            <Table.Cell>{item.sizevariant}</Table.Cell>
                            <Table.Cell>{item.totalpiece}</Table.Cell>
                        </Table.Row>
                    ))}
                    <Table.Row className="bg-gray-100 font-bold">
                        <Table.Cell colSpan="2" className="text-right">Grand Total:</Table.Cell>
                        <Table.Cell>{totalPieces}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );
}

export default CGroupBoxingQuantity;
